import { formatAddress } from '@mysten/sui/utils';
import { FC } from 'react';
import { ParrotCoinStruct } from 'src/types';
import styles from './token-info.module.scss';
import copyIcon from '@assets/images/parrot/copy.svg';
import { numericFormat } from '@utils/index';
import { useCopyToClipboard } from 'react-use';
import { toast } from 'react-toastify';
interface OwnProps {
  coinB: ParrotCoinStruct | undefined;
  coinA: ParrotCoinStruct | undefined;
}
const TokenInfo: FC<OwnProps> = ({ coinA, coinB }) => {
  const [, copy] = useCopyToClipboard();

  const handleCopy = (value: string) => {
    copy(value);
    toast('Address is copied');
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_con}>
        <table width={'100%'}>
          <thead>
            <tr>
              <th align="left">Token</th>
              <th>Holders</th>
              <th align="right">Mkt Cap</th>
            </tr>
          </thead>
          <tbody>
            {coinA && (
              <tr>
                <td>
                  <div className={styles.token}>
                    <img src={coinA.iconUrl || ''} />
                    <div className={styles.token_con}>
                      <div className={styles.token_top}>
                        <span>{coinA.name}</span>
                        <img src="" />
                        <img src="" />
                        <img src="" />
                      </div>
                      <div className={styles.token_bottom}>
                        <span>{coinA.symbol}</span>
                        <span>{formatAddress(coinA.type)}</span>
                        <img src={copyIcon} onClick={() => handleCopy(coinA.type)} />
                      </div>
                    </div>
                  </div>
                </td>
                <td align="center">{numericFormat(coinA.holders_count || '0')}</td>
                <td align="right">${numericFormat(coinA.market_cap || '0')}</td>
              </tr>
            )}

            {coinB && (
              <tr>
                <td>
                  <div className={styles.token}>
                    <img src={coinB.iconUrl || ''} />
                    <div className={styles.token_con}>
                      <div className={styles.token_top}>
                        <span>{coinB.name}</span>
                        <img src="" />
                        <img src="" />
                        <img src="" />
                      </div>
                      <div className={styles.token_bottom}>
                        <span>{coinB.symbol}</span>
                        <span>{formatAddress(coinB.type)}</span>
                        <img src={copyIcon} onClick={() => handleCopy(coinB.type)} />
                      </div>
                    </div>
                  </div>
                </td>
                <td align="center">{numericFormat(coinB.holders_count || '0')}</td>
                <td align="right">${numericFormat(coinB.market_cap || '0')}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TokenInfo;
